module.exports = __webpack_public_path__ + "img/icon_mine_calture.3429dae5.png";